<app-base-page>
  <security-login
    passwordForgotLink="/password-forgot"
    [notice]="notice()"
    (loggedInEvent)="loggedIn($event)"
  ></security-login>
</app-base-page>
